export default {
	// Config
	apiKey: "AIzaSyB7-04jqMqV2A7RvjVycCy-anx4QxLXbA8",
  authDomain: "sherbinski-mytrace.firebaseapp.com",
  projectId: "sherbinski-mytrace",
  storageBucket: "sherbinski-mytrace.firebasestorage.app",
  messagingSenderId: "353242305650",
  appId: "1:353242305650:web:a04e4d223c3e35cd831eeb"
};
